const isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
// 路由配置
const options = {
  mode: 'history',
  routes: [
    {
      path: '*',
      name: '404',
      component:  () => {
        if (isMobile) {
          return import('@/pages/mobile/index/UbiIndex')
        } else {
          return import('@/pages/pc/exception/404')
        }
      }
    },
    {
      path: '/404',
      name: 'exception_404',
      component:  () => {
        if (isMobile) {
          return import('@/pages/mobile/exception/404')
        } else {
          return import('@/pages/pc/exception/404')
        }
      }
    },
    {
      path: '/index',
      name: 'index',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/index/UbiIndex')
        } else {
          return import('@/pages/pc/index/UbiIndex')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/',
      name: 'home',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/index/UbiIndex')
        } else {
          return import('@/pages/pc/index/UbiIndex')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/project',
      name: 'project',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/project/UbiProject')
        } else {
          return import('@/pages/pc/project/UbiProject')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/project/:id',
      name: 'detail',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/index/UbiDetail')
        } else {
          return import('@/pages/pc/index/UbiDetail')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/pay/:id',
      name: 'pay',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/index/UbiPay')
        } else {
          return import('@/pages/pc/index/UbiPay')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/result/:id',
      name: 'result',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/index/UbiPayResult')
        } else {
          return import('@/pages/pc/index/UbiPayResult')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/user/order',
      name: 'user_order',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/user/UbiOrder')
        } else {
          return import('@/pages/pc/user/UbiUser')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/my',
      name: 'my',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/user/UbiUser')
        } else {
          return import('@/pages/pc/user/UbiUser')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/order',
      name: 'order',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/user/UbiOrder')
        } else {
          return import('@/pages/pc/user/UbiUser')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/order/:id',
      name: 'orderId',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/order/UbiOrderDetail')
        } else {
          return import('@/pages/pc/order/UbiOrderDetail')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/user/favorite',
      name: 'user_favorite',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/user/UbiFavorite')
        } else {
          return import('@/pages/pc/user/UbiFavorite')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/user/profile',
      name: 'profile',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/user/UbiProfile')
        } else {
          return import('@/pages/pc/user/UbiProfile')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/help',
      name: 'help',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/help/UbiHelp')
        } else {
          return import('@/pages/pc/help/UbiHelp')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/about/UbiAbout')
        } else {
          return import('@/pages/pc/about/UbiAbout')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/ai/topic',
      name: 'topic',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/ai/UbiTopic')
        } else {
          return import('@/pages/pc/ai/UbiTopic')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/ai/outline',
      name: 'outline',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/ai/UbiOutline')
        } else {
          return import('@/pages/pc/ai/UbiOutline')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/ai/ppt',
      name: 'ppt',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/ai/UbiPPT')
        } else {
          return import('@/pages/pc/ai/UbiPPT')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/user/ppt',
      name: 'user_ppt',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/user/UbiUserPPT')
        } else {
          return import('@/pages/pc/user/UbiUserPPT')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/ppt/:id',
      name: 'ppt_detail',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/user/UbiPPTDetail')
        } else {
          return import('@/pages/pc/user/UbiPPTDetail')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
    {
      path: '/user/project',
      name: 'user_project',
      component: () => {
        if (isMobile) {
          return import('@/pages/mobile/user/UbiUserProject')
        } else {
          return import('@/pages/pc/user/UbiUserProject')
        }
      },
      meta: {
        title: '优毕网-一站式服务平台'
      }
    },
  ]
}

export default options